export default __webpack_public_path__ + "static/media/SOTD_2.808b15f6.png";